import { OG_DEFAULT } from "@/seo/ogImages";
import type { BlogFrontmatter } from "./types";

// Kein eigenes Motiv -> Default-OG-Bild (1200x630) aus src/seo/ogImages.ts.
const OG_IMAGE = OG_DEFAULT.image;

export const frontmatter: BlogFrontmatter = {
  title: "LinkedIn Sales Navigator: der Guide für den B2B-Vertrieb",
  slug: "linkedin-sales-navigator-guide",
  description:
    "Sales Navigator richtig nutzen: Zielaccounts finden, Buying-Center mappen und Signale erkennen. Praktische Tipps für planbares LinkedIn-Prospecting im B2B.",
  primaryKeyword: "sales navigator tipps",
  secondaryKeywords: ["linkedin sales navigator", "b2b prospecting linkedin"],
  author: "moritz",
  datePublished: "2026-07-05",
  dateModified: "2026-07-05",
  image: OG_IMAGE,
  imageAlt: "Illustration: LinkedIn Sales Navigator für B2B-Prospecting",
  internalLinks: ["/abm", "/blog/linkedin-outbound-ohne-spam"],
  draft: true,
  kurzGesagt:
    "Der Sales Navigator ist kein Kontakt-Staubsauger, sondern ein Zielsystem: Er hilft, die richtigen Accounts und Entscheider zu finden und Kaufsignale zu erkennen. Sein Wert entsteht erst im Zusammenspiel mit einer klaren ABM-Zielliste und einem sauberen Outbound-Prozess.",
  faq: [
    { q: "Lohnt sich Sales Navigator für kleine Teams?", a: "Stub: wird ausgearbeitet." },
    { q: "Welche Filter sind am wichtigsten?", a: "Stub: wird ausgearbeitet." },
    { q: "Wie exportiert man Leads DSGVO-konform?", a: "Stub: wird ausgearbeitet." },
  ],
};

export default function Article() {
  return (
    <>
      <p>
        <em>Entwurf / Gliederung. Volltext folgt.</em>
      </p>
      <h2>Gliederung</h2>
      <ul>
        <li>Was der Sales Navigator kann und was nicht</li>
        <li>Zielaccounts und Buying-Center mit Lead-/Account-Filtern mappen</li>
        <li>Kaufsignale erkennen (Jobwechsel, Wachstum, Aktivität)</li>
        <li>These: Prospecting ohne ABM-Zielliste ist teures Streuen</li>
        <li>Beispiel-Suchstring für einen typischen B2B-ICP</li>
        <li>Übergang in einen spamfreien Outbound-Prozess</li>
      </ul>
    </>
  );
}
